import { i18n } from "src/js/i18n";
import { Locale } from "../../../locales";
import { userStore } from "../store";

export function updateUserLocale(locale: Locale) {
  userStore.locale = locale;
  i18n.locale = locale;
}
